import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import _notification from 'modules/notification';
import DropdownList from 'components/controls/DropdownList';
import { Card, Table, Modal, Icon } from 'antd';
import EmptyState from 'components/enterprise/EmptyState';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import PageHeader from 'components/enterprise/PageHeader';
import HeaderSearchBox from 'components/table/HeaderSearchBox';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import TextArea from 'components/controls/TextArea';
import ButtonComponent from 'components/controls/Button';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';

class CenterMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 10, current: 1 },
            highlightedRowID: 0,
            data: [],
            exams: [],
            rowData: {},
            loading: false,
            showModel: false,
            showMessageBox: false,
            centerError: "",
            Address_Error: "",
            Exam_Error: "",
        };
    }

    componentDidMount() {
        this.getAllCategory();
        this.getAllExams();
    }

    //API operations
    getAllCategory = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let centerList = await _AdminService.GetAllCenter();
                    //console.log("categoryList Data: ", centerList.data);

                    this.setState({
                        ...this.state,
                        data: centerList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getAllExams = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let examsList = await _AdminService.GetAllPost();
                    //console.log("categoryList Data: ", examsList.data);

                    this.setState({
                        ...this.state,
                        exams: examsList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    handleUpdate = async (input) => {
        if (this.validateFormData()) {
            return
        }

        const params = {
            Name: this.state.rowData.Name.trim(),
            Description: this.state.rowData.Description ? this.state.rowData.Description.trim() : '',
            Id: this.state.rowData.Id,
            Address: this.state.rowData.Address.trim(),
            AppliedPost_Id: this.state.rowData.AppliedPost_Id
        }

        //console.log("Final data: ", params);

        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.CreateCenter(params);
                    //console.log("Post response: ", response);
                    if (response.status == 200) {
                        _notification.showMessage('success', "Center saved successfully.");
                        this.setState({
                            centerError: "",
                            Address_Error: "",
                            Exam_Error: "",
                            showModel: false,
                            loading: false,
                            highlightedRowID: params.Id
                        });
                        this.getAllCategory();
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }

    deletePost = async () => {       
        try {
            const response = await _AdminService.DeleteCenter(this.state.rowData.Id);
            //console.log("Post response: ", response);
            if (response.status == 200 && response.data.IsSuccess) {
                _notification.showMessage('success', "Center deleted successfully.");
                this.setState({
                    centerError: "",
                    Address_Error: "",
                    Exam_Error: "",
                    showModel: false
                });
                this.getAllCategory();
            }
            else {
                _notification.showMessage('error', response.data.Message);
            }
        } catch (e) {
            _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
        }
    }

    //Table action link clicks
    onEditClick = (value) => {
        //console.log('params ', value);
        this.setState({ rowData: value, showModel: true, highlightedRowID: 0 },()=>{
            window.scrollTo(0, 0);
        });
    };

    onDeleteClick = (value) => {
        //console.log('params ', value);
        this.setState({ rowData: value, showMessageBox: true, highlightedRowID: 0 });
    };

    onTableAction = (pagination, filters, sorter, extra) => {
        //console.log('onTableAction ', pagination, filters, sorter, extra);
        this.setState({ pagination: pagination, highlightedRowID: 0 });
    }

    handleSearch = (selectedKeys, confirm, dataIndex) => () => {
        confirm();
        this.setState({ searchText: selectedKeys[0], searchedColumn: dataIndex });
    }

    handleReset = (clearFilters, dataIndex) => () => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <HeaderSearchBox
                setSelectedKeys={setSelectedKeys}
                selectedKeys={selectedKeys}
                confirm={confirm}
                clearFilters={clearFilters}
                stateName={dataIndex}
                handleSearch={this.handleSearch}
                handleReset={this.handleReset}
            />
        ),
        filterIcon: (filtered) => <Icon type="search" style={{ color: filtered ? 'var(--admin-primary)' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex] ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()) : false,
    })

    //Message box confirm delete click
    onConfirmDelete = (value) => {
        //console.log('reached in delete:  ', value);
        this.setState({ showMessageBox: false });
        this.deletePost(value);
    }

    closeMessageBox(value = false) {
        this.setState({ showMessageBox: value });
    }

    // Add new record click
    onAddNewRecordClick(modelToggle) {
        this.setState({ showModel: modelToggle, rowData: {} });
    }

    hideModelWindow() {
        this.setState({ showModel: false, rowData: {}, centerError: '', Address_Error: '', Exam_Error: "" });
    }

    onTextChange = ({ target: { name, value } }) => {
        //console.log(name, ' ', value);
        if (name == 'Name' && value.length > 50)
            return;

        if (name == 'Description' && value.length > 30)
            return;

        if (name == 'Address' && value.length > 200)
            return;

        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [name]: value }
        });
    }

    onExamChange = (event) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [event.target.name]: event.target.value }
        });
    }

    validateFormData = () => {
        let body = this.state.rowData;

        this.setState({
            centerError: '',
            Address_Error: '',
            Exam_Error: "",
        });

        let hasError = false;

        if (!body.Name || !body.Name.trim()) {
            this.setState({ centerError: 'Please enter valid Center Name' });
            hasError = true
        }

        if (!body.Address || !body.Address.trim()) {
            this.setState({ Address_Error: 'Please enter valid Address' });
            hasError = true
        }

        if (!body.AppliedPost_Id) {
            this.setState({ Exam_Error: 'Please select Post/Exam' });
            hasError = true
        }

        return hasError;
    }

    render() {
        const TableColumns = [
            {
                title: 'Center Name',
                dataIndex: 'Name',
                width: '25%',
                key: 'Name',
                sorter: (a, b) => a.Name > b.Name,
                ...this.getColumnSearchProps('Name'),
            },
            {
                title: 'Location',
                dataIndex: 'Description',
                filterSearch: true,
                width: '15%',
                key: 'Description',
                sorter: (a, b) => a.Description > b.Description,
            },
            {
                title: 'Post/Exam',
                dataIndex: 'PostName',
                filterSearch: true,
                width: '18%',
                key: 'PostName',
                sorter: (a, b) => a.PostName > b.PostName,
            },
            {
                title: 'Address',
                dataIndex: 'Address',
                filterSearch: true,
                width: '40%',
                key: 'Address',
                sorter: (a, b) => a.Address > b.Address,
            },
            {
                title: 'Action',
                dataIndex: '',
                key: 'Id',
                render: (value) => {
                    return (
                        <>
                            <ButtonComponent type="button" value="Edit" className="button-global button-border small autoHeight mr-2" onClick={(event) => this.onEditClick(value)} />
                            <ButtonComponent type="button" value="Delete" className="button-global button-danger small autoHeight" onClick={(event) => this.onDeleteClick(value)} />
                        </>
                    );
                }
            },
        ];

        if (this.state.loading)
            return <LoadingSpinner />

        return (
            <div className="container-fluid p-3">
                <PageHeader
                    title="Center Master"
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Center Master' }]}
                />
                <div className="analysisWrap">
                    <div style={{ textAlign: 'right' }}>
                        {!this.state.showModel &&
                            <div className="max1200 m-auto mb-2"> 
                                <div className="d-flex align-items-center justify-content-end">
                                    <a className="button-global button-border addbutton autoWidth d-inline-block text-center autoHeight mb-3 mr-2 d-flex align-items-center justify-content-center" 
                                    onClick={() => this.onAddNewRecordClick(true)}><Icon type="plus-circle" className="mr-2 font1rem" /> Add Center</a>
                        
                                </div>
                            </div>  
                        }
                    </div>

                    {this.state.showModel &&    
                        <div className="max1200 m-auto">
                            <div className="ent-panel">
                                <h4 className="heading4">{this.state.rowData ? this.state.rowData.Id > 0 ? "Update" : "Add" : "Add"} Center </h4>
                                <div className="admin-inner-wrap p-3">
                                    <div className="row flex-sm-row ">
                                        <div className="mb-2 col-sm-4">
                                            <MyInput id="Name"
                                                type="text"
                                                key="Name"
                                                name="Name"
                                                heading="Center Name"
                                                value={this.state.rowData.Name ? this.state.rowData.Name : ""}
                                                onChange={this.onTextChange}
                                                isRequired={true}
                                                errorState={this.state.centerError}
                                                errorMessage={this.state.centerError} />
                                        </div>
                                        <div className="mb-2 col-sm-4">
                                            <MyInput id="Description"
                                                type="text"
                                                key="Description"
                                                name="Description"
                                                heading="Location"
                                                value={this.state.rowData.Description ? this.state.rowData.Description : ""}
                                                onChange={this.onTextChange}
                                                isRequired={false}
                                            //errorState={this.state.centerError}
                                            //errorMessage={this.state.centerError}
                                            />
                                        </div>
                                        <div className="col-sm-4">
                                            <DropdownList
                                                value={this.state.rowData.AppliedPost_Id ? this.state.rowData.AppliedPost_Id : 0}
                                                name="AppliedPost_Id"
                                                onChange={this.onExamChange}
                                                placeholder="Select Exam"
                                                heading={"Exam/Post"}
                                                className="w-100"
                                                wrapClass="wrap"
                                                isRequired={true}
                                                options={this.state.exams}
                                                errorState={this.state.Exam_Error}
                                                errorMessage={this.state.Exam_Error}
                                            />
                                        </div>
                                        <div className="col-sm-12">
                                            <label htmlFor="Address" className="card-holder-name">Address<span className="color-red">*</span></label>
                                            <TextArea id="Address"
                                                type="text"
                                                key="Address"
                                                name="Address"
                                                rows="4"
                                                value={this.state.rowData.Address ? this.state.rowData.Address : ""}
                                                onChange={this.onTextChange}
                                                isRequired={false}
                                                errorState={this.state.Address_Error}
                                                errorMessage={this.state.Address_Error} />
                                        </div>
                                        
                                    </div>
                                </div>  
                                <div className="pt-4 buttonAlignCenter" >
                                    <ButtonComponent type="button" value="Cancel" onClick={() => this.hideModelWindow()} className="button-global button-secondary mr-4 autoHeight small" />
                                    <ButtonComponent type="button" value="Save" onClick={this.handleUpdate} className="button-global button-primary autoHeight small" disabled={this.state.loading} />
                                </div>
                            </div>
                        </div>              
                        } 
                        <div className="max1200 m-auto">
                        <Table size='small'
                            bordered
                            rowKey='Id'
                            columns={TableColumns}
                            dataSource={this.state.data}
                            pagination={this.state.pagination}
                            footer={() => <label style={{ textAlign: 'right', marginRight: '20px' }}>Total Records: {this.state.data.length}</label>}
                            onChange={this.onTableAction}
                            rowClassName={(record, index) => (index % 2 ? 'odd' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : '') :
                                'even' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : ''))}
                            className="table-striped-rows admin-table"
                            locale={{ emptyText: <EmptyState icon="inbox" title="No Records Found" description="No centers have been added yet." /> }}
                        />
                        </div>
                </div>
                <Modal
                    centered={true}
                    width={400}
                    // bodyStyle={{
                    //     height: "150px",
                    //     padding: 0,
                    //     alignItems: "center",
                    //     justifyContent: "center",
                    //     display: " flex"
                    // }}
                    className="modelPopAnt admin-home"
                    visible={this.state.showMessageBox}
                    onCancel={() => this.closeMessageBox(false)}
                    footer={false}
                >
                    <ConfirmPopup
                        onCancel={() => this.closeMessageBox(false)}
                        onOk={this.onConfirmDelete}
                        popupData={this.state.rowData}
                        message="Are you sure, you want to delete this Center?"
                    />
                </Modal>
            </div>            
        )
    };
}

export default CenterMaster;